import select from 'dom-select';

export const ExternalLink = (el) => {
  const ui = {
    el,
    externalLink: select('.external-link'),
    externalLinkToggle: select('.external-link__toggle'),
    externalLinkCancel: select('.external-link__cancel'),
  };

  const addEvents = () => {
    ui.externalLinkToggle.addEventListener('click', () => {
      ui.externalLink.classList.remove('external-link--is-active');
    });
    ui.externalLinkCancel.addEventListener('click', () => {
      ui.externalLink.classList.remove('external-link--is-active');
    });
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default ExternalLink;